import { app, FrameContexts, pages } from "@microsoft/teams-js";
import { isCADomain, isEUDomain } from "@/utils/utils";
import { sendNotification } from "../apis/foxit";
import { isTeamsRuntime } from "../sdk";
import { getTeamsDataFromUrl } from "../utils/utils";
import store from "@/store";
import { queryFromTeams } from "@/modules/queryData";
import { collaborationAnnotEvent } from "@/store/services";
import {
    ACCOUNT_REGION,
    TEAMS_NOTIFICATION_PARAMS,
    TEAMS_TAB_DATA
} from "../types/notification";
import { TEAMS_ANNOTS_DATA } from "@/modules/queryData.types";

let tabData: TEAMS_TAB_DATA;
let isInTab;
async function getTeamsTabDataWhenOpenInTab() {
    if (!isTeamsRuntime) return null;
    // when we know didn't in tab, return null
    if (isInTab === false) return null;
    // when data cached, return it
    if (tabData) return tabData;
    await app.initialize();
    const {
        page,
        channel,
        team,
        user
    } = await app.getContext();
    // isn't open in tab, mark isInTab = false
    if (page.frameContext !== FrameContexts.content) {
        // eslint-disable-next-line require-atomic-updates
        isInTab = false;
        return null;
    }
    // eslint-disable-next-line require-atomic-updates
    isInTab = true;
    const { entityId } = await pages.getConfig();
    // eslint-disable-next-line require-atomic-updates
    tabData = {
        entityId,
        channelId: channel?.id,
        groupId: team?.groupId,
        tenantId: user?.tenant?.id,
    }
    return tabData;
}

export async function sendNotificationWithinTeams({
    actionType,
    annotName,
    item,
    content,
    annotType,
    pageIndex,
}, addReplyData) {
    if (!queryFromTeams) return;
    const { shareReviewData, reviewSessionID } = store.collaborationStore;
    const memberList = shareReviewData.memberList;
    if (!memberList || memberList.length < 2) return;

    // 'add'| 'reply'|'modify'|'delete'| 'multi'
    let _annotType = annotType;
    let _actionType = actionType === 'update' ? 'modify' : actionType;
    let repliedUserName;
    let parentAnnotName;
    const contentMatch = item && item.match(/<contents>(\S*)<\/contents>/);
    let commentText = (contentMatch && contentMatch[1]) || content;
    if (annotType === 'Reply') {
        const { groupHeader, originAnnot } = addReplyData;
        if (groupHeader) {
            const operandsActionType = collaborationAnnotEvent.getAnnotType(groupHeader.info);
            parentAnnotName = groupHeader.info.name;
            _annotType = operandsActionType[1] || groupHeader.getType();
        }
        if (originAnnot) {
            commentText = originAnnot.getContent();
            repliedUserName = originAnnot.getTitle();
        }
        if (actionType === 'add') {
            _actionType = 'reply';
        }
    }
    // 转换@邮箱格式内容，为@姓名
    if (commentText.startsWith('@')) {
        memberList.forEach(({ userName, email }) => {
            commentText = commentText.replaceAll(email, userName);
        });
    }

    const { fileName } = store.teamsAppStore.teamsFileData || {};
    const { userInfo } = store.userStore;
    const {
        email,
        nickname,
        contentUrl,
        driveId,
        fileId,
        chatUserId,
        entryFrom
    } = getTeamsDataFromUrl();
    const annotData: TEAMS_ANNOTS_DATA = {
        name: annotName,
        pageIndex,
    };
    if (parentAnnotName) annotData.parentName = parentAnnotName;
    const data: TEAMS_NOTIFICATION_PARAMS = {
        entryFrom,
        reviewSessionID,
        teamsEmail: email,
        nickname,
        fileName,
        foxitUserName: userInfo.full_name || userInfo.userEmail || '',
        region: getRegion(),
        type: _actionType,
        annotType: _annotType,
        commentText,
        annotData,
    };

    if (repliedUserName) data.repliedUserName = repliedUserName;
    if (driveId && fileId) {
        data.driveId = driveId;
        data.fileId = fileId;
    } else if (contentUrl) {
        data.contentUrl = decodeURIComponent(contentUrl);
    }
    if(chatUserId) {
        data.chatUserId = chatUserId;
    }
    const tabData = await getTeamsTabDataWhenOpenInTab();
    if (tabData) data.tabData = tabData;

    return sendNotification(data);
}

function getRegion() {
    if (isEUDomain()) return ACCOUNT_REGION.EU;
    if (isCADomain()) return ACCOUNT_REGION.CA;
    return ACCOUNT_REGION.US;
}
